export default function setFunctionName(fn, name) {
  if (
    Object.getOwnPropertyDescriptor &&
    Object.getOwnPropertyDescriptor(fn, 'name') &&
    Object.getOwnPropertyDescriptor(fn, 'name').configurable
  ) {
    Object.defineProperty(fn, 'name', { value: name, enumerable: false});
  }
}



// WEBPACK FOOTER //
// ./utils/setFunctionName.jsx